'use strict';

export default class Link {
  constructor() {
    console.log('Link module');
  }
}
